export const pause = ms => new Promise(res => { setTimeout(() => res(), ms) })